import React, { FC } from "react";
import ButtonCircle from "shared/Button/ButtonCircle";
import rightImg from "images/2-750x500.jpg";
import NcImage from "shared/NcImage/NcImage";
import Badge from "shared/Badge/Badge";
import Input from "shared/Input/Input";

export interface SectionSubscribe2Props {
  className?: string;
  targetlanguage?:string;
}

const SectionSubscribe2: FC<SectionSubscribe2Props> = ({ 
  className = "",
  targetlanguage  = localStorage.getItem("targetlanguage") ? localStorage.getItem("targetlanguage") : (window.location.hostname=='tinyaway.com.tw' || window.location.hostname=='www.tinyaway.com.tw' || window.location.hostname=='localhost')?"zh_tw":"en",
}) => {
  return (
    <div
      className={`nc-SectionSubscribe2 relative flex flex-col lg:flex-row lg:items-center ${className}`}
      data-nc-id="SectionSubscribe2"
    >
      <div className="flex-shrink-0 mb-10 lg:mb-0 lg:mr-10 lg:w-2/5">
        <h2 className="font-semibold text-4xl">{targetlanguage=='zh_tw'?'加入我們的時事通訊':'Join our newsletter'} </h2>
        <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
        {targetlanguage=='zh_tw'?'接收來自 Tiny Away 的獨家電子郵件優惠和促銷訊息。 我們知道，由於需求量龐大，很難預訂您喜歡的週末約會。 加入我們的郵件列表，了解我們最新的小房子以及即將推出的產品！':'Receive exclusive email offers and promotions from Tiny Away. We know it is hard to book your preferred weekend dates due to overwhelming demand. Be on our mailing list and be informed on our newest tiny houses and what’s coming up soon!'}

        </span>
        <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
        {targetlanguage=='zh_tw'?'更重要的是，我們始終為 Tiny Away 系列提供獨家優惠和資訊。 成為第一個被告知的人。':'More importantly, we always have exclusive offers and information for our Tiny Away family. Be the first to be informed.'}
         </span>
        <ul className="space-y-4 mt-5">
          <li className="flex items-center space-x-4">
            <Badge name="01" />
            <span className="font-medium text-neutral-700 dark:text-neutral-300">
            {targetlanguage=='zh_tw'?'享受Tiny Away會員折扣':'Receive Tiny Away member discount'}
            </span>
          </li>
          <li className="flex items-center space-x-4">
            <Badge color="red" name="02" />
            <span className="font-medium text-neutral-700 dark:text-neutral-300">
            {targetlanguage=='zh_tw'?'接收 Tiny Away 時事通訊':'Receive Tiny Away newsletters'}
            </span>
          </li>
        </ul>
        <form className="mt-7 relative max-w-sm">
          <Input
            required
            aria-required
            placeholder={targetlanguage=='zh_tw'?"輸入你的電子郵件信箱":"Enter your email"}
            type="email"
          />
          <ButtonCircle
            type="submit"
            className="absolute transform top-1/2 -translate-y-1/2 right-1"
          >
            <i className="las la-arrow-right text-xl"></i>
          </ButtonCircle>
        </form>
      </div>
      <div className="flex-grow">
        <NcImage src={rightImg} />
      </div>
    </div>
  );
};

export default SectionSubscribe2;
